










import { defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { isTipMessageDetails, TipMessageDetails } from "@scrile/api-provider/dist/api/TipProvider";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "MessagePreviewTip",
  components: { FormatMoney },
  props: {
    message: { type: Object as () => Message, required: true },
    authUserId: { type: String, required: true },
  },
  computed: {
    opponentMessage(): boolean {
      return this.message.senderUser?.id !== this.authUserId;
    },
    details(): TipMessageDetails | null {
      return isTipMessageDetails(this.message.details) ? this.message.details : null;
    },
  },
});
